<script>
  import { fly } from 'svelte/transition';

  export let status = 'fail';
  export let statusMessage = '<p>Your request could not be processed</p>';
</script>

<div
  class="bg-gold-0 border-amber border-left border-left-width-1 d-flex flex-items-center mt-n2 mb-3 p-2"
  in:fly={{ y: -20 }}
  data-testid={`availability-status-${status.toLowerCase()}`}>
  <svg
    class="flex-shrink-0 mr-1 mb-auto"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 23 20"
    width="22"
    height="22">
    <path fill="#2B2B2B" d="M9 4h4v13H9z" /><path
      d="M21.5602 16.1143c.5729 1.0028.6589 1.848.2578 2.5355-.401.6875-1.1745 1.0313-2.3203 1.0313H2.568c-1.1458 0-1.9193-.3438-2.3203-1.0313-.401-.6875-.3151-1.5327.2578-2.5355l2.1918-3.7386c.3726-.6591 1.06-1.848 2.0625-3.5668C5.762 7.0902 6.4496 5.9013 6.8223 5.2422l2.1484-3.7813C9.5437.487 10.2311 0 11.0332 0s1.4896.487 2.0625 1.461l2.1484 3.7812c.3727.659 1.0602 1.848 2.0625 3.5667 1.0024 1.7188 1.6899 2.9077 2.0625 3.5668l2.1911 3.7386zM9.6575 5.6726v5.7578c0 .3726.1217.6877.3651.9453.2434.2576.5514.3866.924.387.3726.0005.7235-.1356 1.0525-.4083.3291-.2727.4939-.5807.4944-.924V5.6726c0-.3727-.1362-.6807-.4084-.924-.2723-.2434-.5945-.3651-.9666-.3651-.3722 0-.7089.129-1.01.387-.3011.2581-.4514.5583-.451.902zm1.375 11.1718c.4011 0 .7519-.1503 1.0526-.451.3006-.3006.451-.6515.451-1.0525 0-.4011-.1504-.7519-.451-1.0526-.3007-.3007-.6515-.451-1.0526-.451-.401 0-.7519.1503-1.0526.451-.3006.3007-.451.6515-.451 1.0526 0 .401.1504.7519.451 1.0525.3007.3007.6516.451 1.0526.451z"
      fill="#FDB924" /></svg>
  <div class="availability-status-message">
    {@html statusMessage}
  </div>
</div>

<style>
  .availability-status-message {
    :global(p) {
      font-size: 16px;
      margin: 0;
      font-family: var(--body-font);
    }
  }
</style>
